// 뉴스룸 (보도자료, 최신순)
export const PRESS_RELEASES = [
  {
    id: 'knue-mou-2025-12',
    date: '2025-12-11',
    title: '플랙티컬(주) - 한국교원대 융합교육연구소, 미래 교육 혁신을 위한 업무협약(MOU) 체결',
    summary: '충북 RISE 및 증평 에듀테크 밸리 조성 사업의 성공적 실증을 위해 맞손',
    thumbnail: null,
    sources: [
      { name: '대학저널', url: 'https://dhnews.co.kr/news/view/1065577393272445' },
      { name: '한국강사신문', url: 'https://www.lecturernews.com/news/articleView.html?idxno=192613' },
    ],
    content: `
      <p class="help-press__lead">에듀테크 전문 기업 플랙티컬 주식회사(대표 강연구)는 지난 10일 <strong>한국교원대학교 융합교육연구소</strong>(소장 백성혜)와 '충북 지역혁신중심 대학지원체계(RISE) 기반 증평 에듀테크 밸리 교육 실증 및 에듀테크 산업 활성화'를 위한 <strong>업무협약(MOU)</strong>을 체결했습니다.</p>
      
      <h3>협약 배경</h3>
      <p>이번 협약은 충청북도가 추진하는 <strong>충북 RISE 프로젝트</strong>의 일환인 '증평 에듀테크 밸리' 조성 사업과 연계하여, 미래 교육 환경을 구축하고 실질적인 연구 성과를 도출하기 위해 마련되었습니다.</p>
      
      <h3>주요 협약 내용</h3>
      <ul>
        <li><strong>에듀테크 솔루션</strong>(왓퀴즈 AI 등)의 학교 현장 적용 및 활용 지원</li>
        <li>현장 실증 과정의 <strong>피드백 공유</strong> 및 이를 기반으로 한 서비스 고도화</li>
        <li>교사 및 학생 대상 <strong>에듀테크 활용 연수</strong> 및 교육 프로그램 공동 운영</li>
        <li>충북 RISE 및 증평 에듀테크 밸리 사업 <strong>성과 확산</strong>을 위한 상호 협력</li>
      </ul>
      
      <h3>기대 효과</h3>
      <p>플랙티컬은 자사의 핵심 솔루션인 생성형 AI 기반 퀴즈 및 평가 플랫폼 <strong>'왓퀴즈(WhatQuiz AI)'</strong>를 실증 대상 학교에 제공하고, 기술 지원 및 사용자 교육을 담당하게 됩니다.</p>
      <p>연구소는 실증 대상 학교 및 학급 선정, <strong>효과성 검증</strong>을 위한 연구 설계, 학습 데이터 분석 등 전문적인 컨설팅과 피드백을 제공하여 서비스의 교육적 효과를 검증할 예정입니다.</p>
      
      <blockquote class="help-press__quote">
        <p>"이번 협약은 대학의 연구 역량과 기업의 기술력이 만나 지역 교육 발전에 기여하는 모범적인 사례가 될 것입니다. 체계적인 실증 연구를 통해 에듀테크 기반의 미래 교육 환경을 선도해 나가겠습니다."</p>
        <cite>— 백성혜 소장, 한국교원대학교 융합교육연구소</cite>
      </blockquote>
      
      <blockquote class="help-press__quote">
        <p>"대한민국 최고의 교원 양성 기관인 한국교원대학교의 전문 연구소와 함께하게 되어 매우 뜻깊습니다. 현장의 목소리가 담긴 실증 데이터를 바탕으로 서비스를 고도화하여, 충북 지역을 넘어 글로벌 경쟁력을 갖춘 에듀테크 기업으로 도약하겠습니다."</p>
        <cite>— 강연구 대표, 플랙티컬 주식회사</cite>
      </blockquote>
      
      <h3>향후 계획</h3>
      <p>양 기관은 이번 협약을 기점으로 증평 에듀테크 밸리 내에서 <strong>AI 디지털 교과서 활용</strong> 등 급변하는 교육 환경에 대비한 교사 연수 프로그램을 공동 기획하는 등 다각적인 협력을 이어갈 예정입니다.</p>
    `,
  },
];
